<template>
  <v-container>
    <v-card max-width="800px" class="mx-auto" :elevation="8">
      <v-card-title>
        Your Account
      </v-card-title>
      <v-card-subtitle>
        {{$store.state.account && $store.state.account.email ? $store.state.account.email : ''}}
      </v-card-subtitle>
      <v-card-text class="text-right d-block">
        <v-row v-if="!$store.state.account.subscribed">
          <v-col :cols="12" :sm="6" :md="6" :lg="5" :offset-sm="6" :offset-lg="7">
            <v-btn
                block
                color="accent"
                @click="startTeamQuestions"
                :disabled="loadingStartSubscriptionUrl"
                >
              Start subscription
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <template v-if="$store.getters.isTeamOwner">
            <v-col :cols="12" :sm="6" :md="6" :lg="5" :offset-sm="6" :offset-lg="7">
              <v-btn
                  block
                  color="secondary"
                  @click="openCustomerPortal"
                  :disabled="loadingSubscriptionUrl"
                  :loading="loadingSubscriptionUrl">
                Manage Subscription
              </v-btn>
            </v-col>
            <v-col :cols="12" :sm="6" :md="6" :lg="5" :offset-sm="6" :offset-lg="7">
              <v-btn
                  block
                  outlined
                  @click="buyCamera"
                  :disabled="loadingBuyCameraUrl"
                  :loading="loadingBuyCameraUrl">
                Order Camera
              </v-btn>
            </v-col>
          </template>
        </v-row>
        <v-row>
          <v-col :cols="12" :sm="6" :md="6" :lg="5" :offset-sm="6" :offset-lg="7">
            <v-btn block outlined @click="changePassword">
              Change Password
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="askTeamQuestions" max-width="600px" persistent :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <div class="d-flex pa-5">
          <div class="pr-2">
            How many agents from your team will use Torvue?
            <div class="caption font-italic pt-2">If you're not a part of a team, just leave it at 1.</div>
          </div>
          <div class="my-auto mx-auto" style="min-width: 135px;">
            <div class="d-flex align-center justify-center">
              <v-btn icon @click="subscriptionQuantity--" :disabled="subscriptionQuantity <= 1" class="mr-4"><v-icon>mdi-minus</v-icon></v-btn>
              <v-text-field v-model="subscriptionQuantity" type="number" style="max-width: 3em;" class="centered-input mt-0 pt-0" hide-spin-buttons hide-details single-line :disabled="loadingStartSubscriptionUrl" />
              <v-btn icon @click="subscriptionQuantity++" class="ml-4"><v-icon>mdi-plus</v-icon></v-btn>
            </div>
          </div>
        </div>

        <v-expand-transition >
          <div class="d-flex pa-5" v-if="subscriptionQuantity > 1">
            <div class="pr-2">
              How many camera bundles would you like to order?
              <div class="caption font-italic pt-2">Cameras can be shared.</div>
            </div>
            <div class="my-auto mx-auto" style="min-width: 135px;">
              <div class="d-flex align-center justify-center">
                <v-btn icon @click="cameraQuantity--" :disabled="cameraQuantity <= 1" class="mr-4"><v-icon>mdi-minus</v-icon></v-btn>
                <v-text-field v-model="cameraQuantity" type="number" style="max-width: 3em;" class="centered-input mt-0 pt-0" hide-spin-buttons hide-details single-line :disabled="loadingStartSubscriptionUrl" />
                <v-btn icon @click="cameraQuantity++" :disabled="cameraQuantity > 10 || cameraQuantity >= subscriptionQuantity" class="ml-4"><v-icon>mdi-plus</v-icon></v-btn>
              </div>
            </div>
          </div>
        </v-expand-transition>
        <v-card-actions>
          <v-btn color="secondary" @click="askTeamQuestions = false" :disabled="loadingStartSubscriptionUrl">Cancel</v-btn>
          <v-spacer />
          <v-btn color="primary" @click="startSubscription" :loading="loadingStartSubscriptionUrl" :disabled="loadingStartSubscriptionUrl">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@/services/aws/Api'




export default {
  name: "Account",
  beforeMount() {
    let tsubscriptionQuantity = parseInt(localStorage.getItem('subscription-quantity'))
    if(isNaN(tsubscriptionQuantity)) {
      this.subscriptionQuantity = 1
    } else {
      this.subscriptionQuantity = tsubscriptionQuantity
    }

    let tcameraQuantity = parseInt(localStorage.getItem('camera-quantity'))
    if(isNaN(tcameraQuantity)) {
      this.cameraQuantity = 1
    } else {
      this.cameraQuantity = tcameraQuantity
    }
  },
  data() {
    return {
      askTeamQuestions: false,
      subscriptionQuantity: 1,
      cameraQuantity: 1,
      loadingSubscriptionUrl: false,
      loadingStartSubscriptionUrl : false,
      loadingBuyCameraUrl: false
    }
  },
  methods: {
    changePassword() {
      this.$swal({
        title: 'Change password',
        html: `<div style="text-align: left;">
To change your password, logout then click the "Forgot password?" link on the Login page.
</div>`
      })
    },
    async openCustomerPortal() {
      try {
        this.loadingSubscriptionUrl = true
        const response = await Api.createStripeBillingUrl(this.$store.state.credentials)

        if(!response.data || !response.data.redirect) {
          throw new Error('bad response')
        }

        window.location.replace(response.data.redirect)
      } catch(e) {
        console.error(e)
        await this.$swal('Something went wrong.  Please refresh the page and try again.  If this repeatedly occurs, contact support@torvue.com.')
        window.location.reload()
      }
    },
    async startTeamQuestions() {
      this.askTeamQuestions = true
    },
    async startSubscription() {
      try {
        this.loadingStartSubscriptionUrl = true

        const debug = localStorage.getItem('debug') === 'true'

        const request = {
          mode: 'subscription',
          lineItems: [
            {
              price: process.env.VUE_APP_TORVUE_SUBSCRIPTION_PRICE_ID,
              quantity: this.subscriptionQuantity,
              adjustable_quantity: {
                enabled: true,
                minimum: 1,
                maximum: 1000
              }
            },
            {
              price: process.env.VUE_APP_TORVUE_CAMERA_PRICE_ID,
              quantity: this.cameraQuantity,
              adjustable_quantity: {
                enabled: true,
                minimum: 0,
                maximum: 10
              }
            }
          ],
          // promoCode: process.env.VUE_APP_BETA_PROMO_CODE,
          allowPromoCodes: true,
          successUrl: 'justSubscribed',
          cancelUrl: 'account'
        }

        const promoCode = localStorage.getItem('promo-code')

        if(promoCode) {
          delete request.allowPromoCodes
          request.promoCode = promoCode
        }

        // if(debug) {
        //   delete request.promoCode
        //   request.allowPromoCodes = true
        // }

        const response = await Api.createStripeCheckoutUrl(this.$store.state.credentials, request)

        if(!response.data || !response.data.redirect) {
          throw new Error('bad response')
        }

        window.location.replace(response.data.redirect)
      } catch(e) {
        console.error(e)
        await this.$swal('Something went wrong.  Please refresh the page and try again.  If this repeatedly occurs, contact support@torvue.com.')
        window.location.reload()
      }
    },
    async buyCamera() {
      try {
        this.loadingBuyCameraUrl = true
        const request = {
          mode: 'payment',
          lineItems: [
            {
              price: process.env.VUE_APP_TORVUE_CAMERA_PRICE_ID,
              quantity: 1
            }
          ],
          successUrl: 'justBoughtCamera',
          cancelUrl: 'account'
        }
        const response = await Api.createStripeCheckoutUrl(this.$store.state.credentials, request)

        if(!response.data || !response.data.redirect) {
          throw new Error('bad response')
        }

        window.location.replace(response.data.redirect)
      } catch(e) {
        console.error(e)
        await this.$swal('Something went wrong.  Please refresh the page and try again.  If this repeatedly occurs, contact support@torvue.com.')
        window.location.reload()
      }
    }
  },
  mounted() {
    if(this.$route.query && this.$route.query.subscribe && this.$store.state.account && !this.$store.state.account.subscribed) {
      // this.startSubscription()
      this.startTeamQuestions()
    } else if(this.$route.query && this.$route.query.buyCamera) {
      this.buyCamera()
    } else if(this.$route.query && this.$route.query.openCustomerPortal) {
      this.openCustomerPortal()
    }
  }
}
</script>

<style scoped>

.centered-input >>> input {
  text-align: center;
}

</style>
